import Dashboard from "components/layout/Dashboard";
import DashboardContent from "components/layout/DashboardContent";
import DashboardHeader from "components/layout/DashboardHeader";
import ExposureConfig from "components/settings/ExposuresConfig";
import Feedback from "components/settings/Feedback";
import IndustryClassConfig from "components/settings/IndustryClassConfig";
import PeopleConfig from "components/settings/PeopleConfig";
import ScorecardPlanConfig from "components/settings/ScorecardPlanConfig";
import UnderwritersConfig from "components/settings/UnderwritersConfig";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import * as userSelectors from "store/selectors/user/userSelectors";

const SettingsConsole = () => {
  const userConfig = useSelector(userSelectors.selectUserConfig);

  const tabs = [
    {
      title: "Industry Class",
      path: "industry-class",
      defaultVisibility: false,
      element: <IndustryClassConfig />,
    },
    {
      title: "Exposures",
      path: "exposures",
      defaultVisibility: false,
      element: <ExposureConfig />,
    },
    {
      title: "Underwriters",
      path: "underwriters",
      defaultVisibility: false,
      element: <UnderwritersConfig />,
    },
    {
      title: "People",
      path: "people",
      defaultVisibility: false,
      element: <PeopleConfig />,
    },
    {
      title: "Scorecard Plan",
      path: "scorecard-plan",
      defaultVisibility: false,
      element: <ScorecardPlanConfig />,
    },
    {
      title: "Feedback",
      path: "feedback",
      defaultVisibility: true,
      element: <Feedback />,
    },
  ].filter(
    (tab) =>
      userConfig?.componentVisibility?.[`settings.${tab?.path}`] ??
      tab.defaultVisibility
  );

  if (tabs.length === 0) {
    return <Navigate to={"/"} replace={true} />;
  }

  return (
    <div className={"app"}>
      <Dashboard>
        <DashboardHeader
          tabs={tabs}
          hideActiveSubmission
          isFullWidth
          topNavBorderless={true}
        />
        <DashboardContent>
          <Routes>
            {tabs.map(({ element, path }) => (
              <Route key={path} path={`${path}/*`} element={element} />
            ))}
            <Route
              path={"*"}
              element={<Navigate to={tabs[0].path} replace={true} />}
            />
          </Routes>
        </DashboardContent>
      </Dashboard>
    </div>
  );
};

export default SettingsConsole;
